import { newToolFilterOAuthMcp } from "../oauth.ts";

export const morningstarMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.morningstar.com/favicon-192.png",
  url: "https://mcp.morningstar.com/mcp",
  label: "Morningstar",
});
